import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EntityStatus } from '@core';
import { IncidentSeverityCountComponent } from '@incidents';
import { IncidentSeverity } from '@models';
import { StatusCountComponent } from '@ui';

@Component({
  imports: [RouterLink, StatusCountComponent, IncidentSeverityCountComponent],
  selector: 'avs-space-card-info',
  templateUrl: './space-card-info.component.html',
})
export class SpaceCardInfoComponent {
  status = input<EntityStatus>(EntityStatus.Active);
  criticalAndMajorSeverityCount = input(0);
  minorSeverityCount = input(0);
  spaceLink = input<string[]>([]);
  name = input('');
  address = input('');
  deviceActive = input(0);
  devicePaused = input(0);

  protected readonly eEntityStatus = EntityStatus;
  protected readonly eIncidentSeverity = IncidentSeverity;
}
